import React from 'react';
import { Box, Stack, Typography, Divider, Checkbox, FormControlLabel, TextField, Select, MenuItem, InputAdornment } from '@mui/material';

function fmt(n) {
  return Number(n || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default function SummaryBox({ form, onChange }) {
  const { items = [], vat_rate = 7, include_vat = false, discount = 0, discountType = '%' } = form;

  const subtotal = items.reduce((s, it) => s + (Number(it.quantity) || 0) * (Number(it.unit_price) || 0), 0);
  const discountAmt = discountType === '%' ? (subtotal * discount) / 100 : Number(discount) || 0;
  const afterDiscount = Math.max(0, subtotal - discountAmt);
  const vatAmount = include_vat ? 0 : (afterDiscount * vat_rate) / 100;
  const total = afterDiscount + vatAmount;

  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2.5 }}>
      <Stack spacing={1.5}>
        <Stack direction="row" justifyContent="space-between">
          <Typography color="text.secondary" variant="body2">รวมเป็นเงิน</Typography>
          <Typography variant="body2" fontWeight={600}>฿{fmt(subtotal)}</Typography>
        </Stack>

        {/* Discount input — แสดงตลอด ให้ user กรอกได้ */}
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography color="text.secondary" variant="body2">ส่วนลด</Typography>
          <Stack direction="row" spacing={0.5} alignItems="center">
            <TextField
              type="number"
              value={discount}
              onChange={(e) => onChange('discount', parseFloat(e.target.value) || 0)}
              size="small"
              sx={{ width: 80, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              InputProps={{ endAdornment: <InputAdornment position="end">{discountType === '%' ? '%' : '฿'}</InputAdornment> }}
            />
            <Select
              value={discountType}
              onChange={(e) => onChange('discountType', e.target.value)}
              size="small"
              sx={{ width: 65, borderRadius: 2, '& .MuiSelect-select': { py: 0.75 } }}
            >
              <MenuItem value="%">%</MenuItem>
              <MenuItem value="amount">฿</MenuItem>
            </Select>
            {discountAmt > 0 && (
              <Typography variant="body2" fontWeight={600} color="error.main">
                -฿{fmt(discountAmt)}
              </Typography>
            )}
          </Stack>
        </Stack>

        {/* แสดงยอดหลังหักส่วนลด เฉพาะเมื่อมีส่วนลด */}
        {discountAmt > 0 && (
          <Stack direction="row" justifyContent="space-between">
            <Typography color="text.secondary" variant="body2">หลังหักส่วนลด</Typography>
            <Typography variant="body2" fontWeight={600}>฿{fmt(afterDiscount)}</Typography>
          </Stack>
        )}

        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <FormControlLabel
            control={
              <Checkbox
                checked={!include_vat}
                onChange={(e) => onChange('include_vat', !e.target.checked)}
                size="small"
              />
            }
            label={`VAT ${vat_rate}%`}
            sx={{ m: 0, '& .MuiTypography-root': { fontSize: '0.85rem', color: 'text.secondary' } }}
          />
          <Typography variant="body2" fontWeight={600}>฿{fmt(vatAmount)}</Typography>
        </Stack>

        <Divider />

        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography fontWeight={700}>รวมทั้งสิ้น</Typography>
          <Typography variant="h6" fontWeight={800} color="primary">฿{fmt(total)}</Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
